import { Modal } from "@mui/material";
import { useEffect, useState } from "react";
import Close from "../../Components/Icons/Close";
import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import cssClasses from "./ReassignModal.module.css";
import icon from "../../Assets/Images/reassignTokenModalIcon.svg";
import { supabase } from "../../supabaseClient";

function ReassignModal({
  open,
  handleClose,
  reassign,
  data,
  currentCpId,
  setConfirmationMsg,
}) {
  function closeModal() {
    handleClose();
  }
  function handleChange(e) {
    setHelperText("");
    console.log(e);
    setDropDownValue(e);
    let list = otherFosList.filter((each) => each.name === e)[0];
    console.log(list);
    setSelectedFos(list.fosId);
    setConfirmationMsg(`Leads of ${data.name} are assigned to ${list?.name}`);
  }
  useEffect(() => {
    getOtherFos();
  }, []);

  function reassignLeads() {
    console.log(selectedFos);
    reassign(selectedFos);
  }
  const [dropDownList, setDropDownList] = useState([]);
  const [otherFosList, setOtherFosList] = useState([]);
  const [dropDownValue, setDropDownValue] = useState("");
  const [selectedFos, setSelectedFos] = useState("");
  const [helperText, setHelperText] = useState("");
  async function getOtherFos() {
    const { data, error } = await supabase
      .from("FOS")
      .select("*")
      .eq("cpId", currentCpId)
      .eq("approvalStatus", "approved");
    if (data) {
      setOtherFosList(data);
      data.map((each) => dropDownList.push(each.name));
    } else throw error;
  }
  return (
    <Modal
      open={open}
      onClose={() => closeModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <div className={cssClasses.wrapper}>
        <div className={cssClasses.iconWrapper}>
          <img src={icon} alt="" />
          <div onClick={() => handleClose()} style={{ cursor: "pointer" }}>
            <Close height={"2rem"} width={"2rem"} />
          </div>
        </div>
        <div className={cssClasses.content}>
          <p className={cssClasses.heading}>
            Reassign Current Leads of {data.name} to other FOS
          </p>
          <DropDown
            selectedValue={dropDownValue}
            onChangeSelect={(e) => handleChange(e)}
            list={dropDownList}
            style={{ selectedColor: "#344054" }}
            helperText={helperText}
          />
        </div>
        <div className={cssClasses.footerBtn}>
          <Button
            style={{ color: "#344054", backgroundColor: "#FFFFFF" }}
            btnName="Cancel"
            clicked={() => handleClose()}
          />
          <Button
            style={{ color: "#FFFFFF", backgroundColor: "#155EEF" }}
            btnName="Confirm"
            clicked={() => {
              dropDownValue === ""
                ? setHelperText("Please select Fos")
                : reassignLeads();
            }}
          />
        </div>
      </div>
    </Modal>
  );
}

export default ReassignModal;
